<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12">
        <h1 class="title-default">Resulth Local Connect</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="voltar()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Configure a ponte entre o seu banco de dados local e o Hub Resulth.
        </p>
      </div>
    </div>

    <form [formGroup]="model">
      <!-- Seção Como Funciona -->
      <div class="section-container mb-4">
        <div class="section-title">
          <mat-icon>help_outline</mat-icon>
          <span>Como funciona</span>
        </div>

        <div class="action-card-grid mt-3">
          <app-action-card
            icon="cable"
            title="Conecte seu banco de dados"
            description="O Resulth Local Connect é a ponte tecnológica que conecta o seu banco de dados local ao Hub de inovações.">
          </app-action-card>

          <app-action-card
            icon="vpn_key"
            title="Autenticação segura via Token"
            description="Um token exclusivo é gerado para sua empresa, garantindo que a comunicação seja segura e criptografada.">
          </app-action-card>

          <app-action-card
            icon="sync"
            title="Sincronização automática"
            description="Com ele ativo, você ganha acesso a IA no WhatsApp, integrações com Zoppy, Scanntech e mais.">
            <a href="javascript:void(0)" class="saiba-mais-link" (click)="abrirModalSaibaMais()">Saiba mais</a>
          </app-action-card>
        </div>
      </div>

      <app-ativacao-section-card
        [control]="$any(model.get('utilizaResulthLocalConnect'))"
        titulo="Resulth Local Connect"
        [exibirTituloNoAlerta]="false"
        descricaoAtivo="Resulth Local Connect ativo. Configure a conexão com o banco de dados local abaixo."
        descricaoInativo="Resulth Local Connect inativo. A integração com o banco de dados local está desativada."
        emptyStateTitulo="Resulth Local Connect desativado"
        emptyStateDescricao="Ative a integração no cartão acima para configurar a conexão com o banco de dados local."
        (ativacaoChange)="configResulthLocalConnectChange()">
      </app-ativacao-section-card>

      @if (model.get('utilizaResulthLocalConnect')?.value) {
      <!-- Seção Configuração -->
      <div class="section-container" (change)="configResulthLocalConnectChange()">
        <div class="section-title">
          <mat-icon>settings</mat-icon>
          <span>Configuração</span>
          <div class="section-title-actions ms-auto">
            <button mat-button type="button" class="btn-section" aria-label="Testar conexão"
              [disabled]="_isLoadingButtonTestarConexao"
              (click)="testarConexao()">
              @if (_isLoadingButtonTestarConexao) {
                <mat-spinner diameter="20"></mat-spinner>
              } @else {
                <mat-icon class="material-symbols-outlined">network_check</mat-icon>
                Testar conexão
              }
            </button>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-md-3">
            <mat-form-field appearance="outline">
              <mat-label>Código da filial no BD do Resulth local</mat-label>
              <input matInput formControlName="codFilialBDResulthLocal" type="text" maxlength="2"
                (input)="somenteNumeros($event)" (blur)="formatandoCampo()" />
              @if (model.get('codFilialBDResulthLocal')?.invalid) {
              <mat-error>Informe o código</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Token do ResulthLocalConnect</mat-label>
              <input matInput formControlName="tokenResulthLocalConnect" type="text" />
              <button mat-icon-button matSuffix type="button" (click)="copyToken()"
                [disabled]="!model.get('tokenResulthLocalConnect')?.value" matTooltip="Copiar token">
                <mat-icon>content_copy</mat-icon>
              </button>
              <div matSuffix class="d-inline-block" [matTooltip]="
                    !isEmpresaMatriz && model.get('usaTokenMatrizResulthLocalConnect')?.value
                      ? 'Não é possível regerar o token quando estiver usando o token da matriz'
                      : 'Regerar token'
                  ">
                <button mat-icon-button type="button" (click)="modalConfirmChangeTokenResulthLocalConnect()"
                  [disabled]="!isEmpresaMatriz && model.get('usaTokenMatrizResulthLocalConnect')?.value">
                  <mat-icon>autorenew</mat-icon>
                </button>
              </div>
              @if (model.get('tokenResulthLocalConnect')?.invalid) {
              <mat-error>Informe o token do ResulthLocalConnect</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-md-3 token-matriz-control">
            @if (podeExibirToggleTokenMatriz) {
            <mat-slide-toggle class="app-toggle-compact" formControlName="usaTokenMatrizResulthLocalConnect">
              Usar token da matriz
            </mat-slide-toggle>
            } @else if (isEmpresaMatriz && empresasFiliaisUsandoToken.length > 0) {
            <div class="token-sharing-badge d-flex align-items-center" [matTooltip]="getTextoEmpresasUsandoToken()"
              matTooltipClass="multi-line-tooltip" style="gap: 8px; color: #555;">
              <mat-icon style="color: #0b70c3;">hub</mat-icon>
              <span>{{ empresasFiliaisUsandoToken.length }} {{ empresasFiliaisUsandoToken.length === 1 ? 'filial
                vinculada' : 'filiais vinculadas' }}</span>
            </div>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <mat-form-field appearance="outline">
              <mat-label>Host do BD</mat-label>
              <input matInput formControlName="hostBDResulthLocal" type="text" />
              @if (model.get('hostBDResulthLocal')?.invalid) {
              <mat-error>Informe o host do BD</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field appearance="outline">
              <mat-label>Porta do BD</mat-label>
              <input matInput formControlName="portaBDResulthLocal" type="text" inputmode="numeric"
                [currencyMask]="integerMask" />
              @if (model.get('portaBDResulthLocal')?.invalid) {
              <mat-error>Informe a porta do BD</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field appearance="outline">
              <mat-label>Usuário do BD</mat-label>
              <input matInput formControlName="usuarioBDResulthLocal" type="text" />
              @if (model.get('usuarioBDResulthLocal')?.invalid) {
              <mat-error>Informe o usuário do BD</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field appearance="outline">
              <mat-label>Senha do BD</mat-label>
              <input matInput formControlName="senhaBDResulthLocal" type="password" class="password-input" />
              @if (model.get('senhaBDResulthLocal')?.invalid) {
              <mat-error>Informe a senha do BD</mat-error>
              }
              @if (model.get('senhaBDResulthLocal')?.disabled) {
              <button mat-icon-button matSuffix type="button" (click)="modalConfirmEditSenhaBDResulthLocal()"
                matTooltip="Alterar senha">
                <mat-icon>lock</mat-icon>
              </button>
              }
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-9">
            <mat-form-field appearance="outline">
              <mat-label>Caminho do BD</mat-label>
              <input matInput formControlName="caminhoBDResulthLocal" type="text" />
              @if (model.get('caminhoBDResulthLocal')?.invalid) {
              <mat-error>Informe o caminho do BD</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>
      }
    </form>
  </div>
</div>

<app-footer-action [isLoadingSalvar]="_isLoadingButtonSalvar" [isSalvarDisabled]="buttonDesativado"
  (cancelar)="voltar()" (salvar)="submit()">
</app-footer-action>
